import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentProject } from "../../store/slices/projects";

export const useProjectNavigate = () => {
  const navigate = useNavigate();
  const currentProject = useSelector(selectCurrentProject);

  return useCallback(
    (to, options = {}) => {
      const rawCode = (options.projectCode || currentProject?.code || "").trim();
      const code = rawCode ? rawCode.toUpperCase().slice(0, 3) : null;

      if (!code) {
        navigate(to, options);
        return;
      }

      if (typeof to === "string") {
        if (to.startsWith(`/${code}/`) || to === `/${code}`) {
          navigate(to, options);
          return;
        }

        let path = to;
        if (!path.startsWith("/")) path = `/${path}`;

        const fullPath = `/${code}${path}`;
        navigate(fullPath, options);
      } else {
        const origPath = to.pathname || "";

        if (origPath.startsWith(`/${code}/`) || origPath === `/${code}`) {
          navigate(to, options);
          return;
        }

        let path = origPath;
        if (!path.startsWith("/")) path = `/${path}`;

        const fullPath = `/${code}${path}`;
        navigate({ ...to, pathname: fullPath }, options);
      }
    },
    [navigate, currentProject]
  );
};